/* eslint-disable jsx-a11y/no-static-element-interactions */
// react
import React, { Component } from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

class InputNumber extends Component {
    handleChange = (event) => {
        const { min, max, onChange } = this.props;

        if (!onChange) return;

        const raw = event.target.value.trim();

        if (raw === '') {
            onChange(min ?? 1);
            return;
        }

        let value = parseFloat(raw);

        if (Number.isNaN(value)) value = min ?? 1;
        if (min != null && value < min) value = min;
        if (max != null && value > max) value = max;

        onChange(value);
    };

    handleBlur = (event) => {
        const { min, onChange } = this.props;

        if (!onChange) return;

        const value = parseFloat(event.target.value);
        const effectiveMin = min ?? 1;

        if (event.target.value.trim() === '' || Number.isNaN(value) || value < effectiveMin) {
            onChange(effectiveMin);
        }
    };

    handleAddMouseDown = () => {
        this.change(1);
        this.changeByTimer(1);
    };

    handleSubMouseDown = () => {
        this.change(-1);
        this.changeByTimer(-1);
    };

    /**
     * @param direction - one of [-1, 1]
     */
    change(direction) {
        const {
            value,
            step,
            max,
            min,
            onChange,
        } = this.props;
        let newValue = (value === '' || Number.isNaN(value) ? 0 : value) + step * direction;

        if (max !== null) {
            newValue = Math.min(max, newValue);
        }
        if (min !== null) {
            newValue = Math.max(min, newValue);
        }

        if (newValue !== value) {
            if (onChange) {
                onChange(newValue);
            }
        }
    }

    /**
     * @param direction - one of [-1, 1]
     */
    changeByTimer(direction) {
        let interval;
        const timer = setTimeout(() => {
            interval = setInterval(() => this.change(direction), 50);
        }, 300);

        const documentMouseUp = () => {
            clearTimeout(timer);
            clearInterval(interval);

            document.removeEventListener('mouseup', documentMouseUp, false);
        };

        document.addEventListener('mouseup', documentMouseUp, false);
    }

    render() {
        const {
            size,
            className,
            onChange,
            enableUp,
            enableDown,
            ...otherProps
        } = this.props;

        const classes = classNames('input-number', className);
        const formControlClasses = classNames('form-control input-number__input', {
            'form-control-sm': size === 'sm',
            'form-control-lg': size === 'lg',
        });

        return (
            <div className={classes}>
                <input
                    className={formControlClasses}
                    type="number"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    {...otherProps}
                />

                {<div className="input-number__add" onMouseDown={this.handleAddMouseDown} />}
                {<div className="input-number__sub" onMouseDown={this.handleSubMouseDown} />}
            </div>
        );
    }
}

InputNumber.propTypes = {
    onChange: PropTypes.func,
    size: PropTypes.oneOf(['sm', 'lg']),
    step: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
};

InputNumber.defaultProps = {
    value: '',
    step: 1,
    max: null,
    min: null,
};

export default InputNumber;
